import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
// import vConsole from 'vconsole';
// const a = new vConsole();
// console.log(a)
import iView from 'view-design';
import 'view-design/dist/styles/iview.css';
import './assets/css/layout.css';

Vue.use(iView)

import { sync } from 'vuex-router-sync'
sync(store, router)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
